import { render } from "./BaseLayout3.vue?vue&type=template&id=cefcfc4e&scoped=true"
import script from "./BaseLayout3.vue?vue&type=script&lang=js"
export * from "./BaseLayout3.vue?vue&type=script&lang=js"

import "./BaseLayout3.vue?vue&type=style&index=0&id=cefcfc4e&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cefcfc4e"]])

export default __exports__